<template>
  <!-- PAGE CONTENT BEGINS -->
  <div style="">
    <el-container>
      <el-main>
        <label style="width: 15%">
          <el-select v-model="sex" placeholder="请选择粉丝性别">
            <el-option label="默认" value="请选择"></el-option>
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </label>
        <label style="width: 15%;margin-left: 10px;">
          <el-button @click="list(1)" type="primary" icon="el-icon-search">搜索</el-button>
        </label>

        <el-table :data="tableData" border :row-style="{height:'40px'}" :cell-style="{height:'5px,0',textAlign:'center'}" :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" style="width: 99%;margin-top: 3%">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="id" label="ID" width="150">
          </el-table-column>
          <el-table-column prop="userName" label="微信名" width="160">
          </el-table-column>
          <el-table-column prop="openid" label="openId" width="230">
          </el-table-column>
          <el-table-column label="微信头像" width="120">
            <template slot-scope="scope">
              <img style="width: 80px;height: 80px;" :src="scope.row.headImage" />
            </template>
          </el-table-column>
          <el-table-column prop="iccid" label="绑定卡号" width="180">
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="120">
            <template slot-scope="scope">
              <p v-if="scope.row.sex==1">男</p>
              <p v-if="scope.row.sex==2">女</p>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180">
          </el-table-column>
          <el-table-column prop="city" label="所在城市" width="120">
          </el-table-column>
          <el-table-column prop="country" label="所在国家" width="120">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-if="scope.row.status==0">已解绑</div>
              <div v-if="scope.row.status==1">已关注</div>
            </template>
          </el-table-column>
        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>
  </div>

</template>

<script>
import Pagination from '../../../components/pagination'
export default {
  name: 'etc',
  components: { Pagination },
  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
    _this.appId = _this.$route.params.appId
    _this.list(1)
  },
  data() {
    return {
      sex: '默认',
      tableData: []
    }
  },
  methods: {
    list(page) {
      let _this = this
      if (_this.sex == '默认') {
        _this.sex = 0
      }
      _this.$ajax
        .get(process.env.VUE_APP_SERVER + '/wechat/wx/load-etc/' + _this.appId, {
          params: {
            current: page,
            size: _this.$refs.pagination.size,
            sex: _this.sex
          }
        })
        .then(response => {
          console.log('用户列表', response)
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    }
  }
}
</script>